import { type FetchNftCollectibleByCollectibleIdParams } from '@capsicum/common';

import { nftApi } from '.';

export async function fetchMyCollectible(params: FetchNftCollectibleByCollectibleIdParams) {
	return (await nftApi).fetchNftCollectibleByCollectibleId(params).then(res => res.data);
}
